import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class TaxRates extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			searchCount: 0,
			renderKey: 0
		};
	}

	onSubmitSearch(event) {
		this.mergeState({
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	addTaxRate() {
		this.props.navigate('/Stores/TaxRates/new');
	}
	
	editTaxRate(taxRateId) {
		this.props.setTaxRateEditable(true);
		this.props.navigate('/Stores/TaxRates/' + taxRateId);		
	}

	viewTaxRate(taxRateId) {
		this.props.setTaxRateEditable(false);
		this.props.navigate('/Stores/TaxRates/' + taxRateId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Tax Rates',
			columns: exportColumns,
			entity: 'STORES.TAX_RATES_VW',
			search: null,
			order: 'RATE_ID desc'
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Tax Rates</span>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Stores_TaxRates' table={taxRatesList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='190px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const taxRatesList = {
	query: { entity: 'STORES.TAX_RATES_VW', search: null, order: 'RATE_ID desc' },
	pageSize: 20,
	columns: [	
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addTaxRate()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editTaxRate(props.row.values.RATE_ID)} /> },
		{ Header: 'Rate ID', accessor: 'RATE_ID', width: 100,
			Cell: props => <HashLink onClick={() => props.parent.viewTaxRate(props.value)}>{props.value}</HashLink> },
		{ Header: 'Tax Rate', accessor: 'TAX_PCT', width: 100 },
		{ Header: 'Start Date', accessor: 'START_DATE', width: 100 },
		{ Header: 'End Date', accessor: 'END_DATE', width: 100 },
		{ Header: 'Default Rate', accessor: 'DEFAULT_FLAG', width: 100 },
		{ Header: 'Comments', accessor: 'COMMENTS', width: 400 }
	]
};

const exportColumns = [
	{ Header: 'Rate ID', accessor: 'RATE_ID', width: 20 },
	{ Header: 'Tax Rate', accessor: 'TAX_PCT', width: 20 },
	{ Header: 'Start Date', accessor: 'START_DATE', width: 20 },
	{ Header: 'End Date', accessor: 'END_DATE', width: 20 },
	{ Header: 'Default Rate', accessor: 'DEFAULT_FLAG', width: 20 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 100 }
];

export default withRouter(TaxRates);
